'use strict';exports.__esModule = true;var _slugify = require('./slugify');var _slugify2 = _interopRequireDefault(_slugify);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var formatCityName = function formatCityName(str) {return (0, _slugify2.default)(str);};exports.default =

formatCityName;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/formatCityName.js
// module id = 571
// module chunks = 0